import { useEffect } from 'react';

export const usePageMeta = (title, description, canonicalUrl) => {
  useEffect(() => {
    // Update page title
    if (title) {
      document.title = title;
    }

    // Update meta description
    if (description) {
      let metaDescription = document.querySelector('meta[name="description"]');
      if (!metaDescription) {
        metaDescription = document.createElement('meta');
        metaDescription.name = 'description';
        document.head.appendChild(metaDescription);
      }
      metaDescription.content = description;
    }

    // Update canonical URL
    if (canonicalUrl) {
      let canonicalLink = document.querySelector('link[rel="canonical"]');
      if (!canonicalLink) {
        canonicalLink = document.createElement('link');
        canonicalLink.rel = 'canonical';
        document.head.appendChild(canonicalLink);
      }
      canonicalLink.href = canonicalUrl;
    }

    // Update Open Graph title (many crawlers/social previews use this)
    if (title) {
      let ogTitle = document.querySelector('meta[property="og:title"]');
      if (ogTitle) {
        ogTitle.content = title;
      }
    }

    // Update Open Graph description
    let ogDescription = document.querySelector('meta[property="og:description"]');
    if (description && ogDescription) {
      ogDescription.content = description;
    }

    // Update Open Graph URL
    let ogUrl = document.querySelector('meta[property="og:url"]');
    if (canonicalUrl && ogUrl) {
      ogUrl.content = canonicalUrl;
    }

    // Update Twitter title
    if (title) {
      let twitterTitle = document.querySelector('meta[name="twitter:title"]');
      if (twitterTitle) {
        twitterTitle.content = title;
      }
    }

    // Update Twitter description
    let twitterDescription = document.querySelector('meta[name="twitter:description"]');
    if (description && twitterDescription) {
      twitterDescription.content = description;
    }

    // Update Twitter URL
    let twitterUrl = document.querySelector('meta[name="twitter:url"]');
    if (canonicalUrl && twitterUrl) {
      twitterUrl.content = canonicalUrl;
    }

    // Cleanup function to restore default title and description
    return () => {
      document.title = 'AI Dental Consent Software for UK Practices | Smile Consent';
      const defaultDescription = 'AI dental consent software for UK practices. Generate compliant dental consent forms, send for digital signature, and keep clear audit trails with Smile Consent.';
      const defaultCanonical = 'https://smileconsent.co.uk/';
      
      let metaDescription = document.querySelector('meta[name="description"]');
      if (metaDescription) {
        metaDescription.content = defaultDescription;
      }

      let canonicalLink = document.querySelector('link[rel="canonical"]');
      if (canonicalLink) {
        canonicalLink.href = defaultCanonical;
      }

      let ogTitle = document.querySelector('meta[property="og:title"]');
      if (ogTitle) {
        ogTitle.content = 'AI Dental Consent Software for UK Practices | Smile Consent';
      }

      let ogDescription = document.querySelector('meta[property="og:description"]');
      if (ogDescription) {
        ogDescription.content = defaultDescription;
      }

      let ogUrl = document.querySelector('meta[property="og:url"]');
      if (ogUrl) {
        ogUrl.content = defaultCanonical;
      }

      let twitterTitle = document.querySelector('meta[name="twitter:title"]');
      if (twitterTitle) {
        twitterTitle.content = 'AI Dental Consent Software for UK Practices | Smile Consent';
      }

      let twitterDescription = document.querySelector('meta[name="twitter:description"]');
      if (twitterDescription) {
        twitterDescription.content = defaultDescription;
      }

      let twitterUrl = document.querySelector('meta[name="twitter:url"]');
      if (twitterUrl) {
        twitterUrl.content = defaultCanonical;
      }
    };
  }, [title, description, canonicalUrl]);
}; 